import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestCollectionUpdateVisibility } from '@shared/dto/collection/_requests/request_collection_update_visibility';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { STATE__collections } from '../STATE__collections';

export const remote_collection_update_visibility = createAsyncThunkSafe<void, RequestCollectionUpdateVisibility>(
  ENUM__network_event_client_to_server.COLLECTION_UPDATE_VISIBILITY,
  async (request, thunkApi): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.COLLECTION_UPDATE_VISIBILITY, request);
  },
);

export function init_remote_collection_update_visibility(builder: ActionReducerMapBuilder<STATE__collections>) {
  builder
    .addCase(remote_collection_update_visibility.pending, (state, action) => {
      let request = action.meta.arg;

      let grid2d_collection = state.collections_map.get_or_assert(request.collection_id, { context: 'grid2d_collection' });

      state.collections_map.set(request.collection_id, grid2d_collection.clone({ is_hidden: request.is_hidden }));

      state.collections_map = new Map(state.collections_map);
    })
    .addCase(remote_collection_update_visibility.rejected, (state, action) => {})
    .addCase(remote_collection_update_visibility.fulfilled, (state, action: PayloadAction) => {});
}
